/** Quiz du livreur : état déduit des tentatives (la correction reste côté base). */
import type { TentativeQuiz } from './types'

export const ECHECS_AVANT_BLOCAGE = 3

export interface EtatQuiz {
  reussi: boolean
  /** Échecs postérieurs au dernier déblocage. */
  echecsRecents: number
  tentativesRestantes: number
  bloque: boolean
}

/**
 * `driver_onboarding.quiz_deblocage_at` : le staff « débloque » après 3 échecs,
 * et on ne compte que les échecs postérieurs à cette date. Même règle que la
 * base — ici pour AFFICHER l'état et proposer (ou non) le bouton de déblocage.
 */
export function etatQuiz(tentatives: readonly TentativeQuiz[], deblocageLe: string | null): EtatQuiz {
  const depuis = deblocageLe ? new Date(deblocageLe).getTime() : -Infinity
  const reussi = tentatives.some((t) => t.reussi)
  const echecsRecents = tentatives.filter((t) => !t.reussi && new Date(t.date).getTime() > depuis).length
  const restantes = Math.max(0, ECHECS_AVANT_BLOCAGE - echecsRecents)
  return { reussi, echecsRecents, tentativesRestantes: restantes, bloque: !reussi && restantes === 0 }
}
